import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.message || 'Credenziali non valide');
      } else {
        localStorage.setItem('authToken', data.token);
        // Se esiste già una card parziale, vai al layout, altrimenti inizia dal business info
        const hasBusiness = !!localStorage.getItem('businessInfo');
        navigate(hasBusiness ? '/setup/card-layout' : '/setup/business-info');
      }
    } catch (e) {
      setError('Errore di rete');
    }
    setLoading(false);
  };

  return (
    <div className="container" style={{ maxWidth: 420 }}>
      <div className="step-container">
        <div className="step-header">
          <h2>Accedi</h2>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
          </div>
          {error && <p className="message" style={{ color: '#b00020' }}>{error}</p>}
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Accesso...' : 'Accedi'}
          </button>
          <div style={{ marginTop: 12, textAlign: 'center' }}>
            <a href="/register">Crea un nuovo account</a>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;


